import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text } from '@components'

interface DateTimeFieldProps {
  label: string
  value: string
  onChange: (value: string) => void
  error?: string
  /** Help text under the field (hidden while an error is shown). */
  hint?: string
  testID?: string
  /** `date` = day only (value "YYYY-MM-DD"), default = date and time. */
  mode?: 'datetime' | 'date'
}

/** Web: the browser's native date + time picker (value = "YYYY-MM-DDTHH:mm", local time), or date only. */
export function DateTimeField({ label, value, onChange, error, hint, testID, mode = 'datetime' }: DateTimeFieldProps) {
  const theme = useTheme()
  return (
    <View style={styles.wrapper}>
      <Text type="bodySmallBold" color={theme.colors.secondary}>
        {label}
      </Text>
      <input
        type={mode === 'date' ? 'date' : 'datetime-local'}
        data-testid={testID}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          height: 44,
          borderRadius: 22,
          border: `1px solid ${error ? theme.colors.error : theme.colors.lightGrey}`,
          padding: '0 16px',
          fontSize: 15,
          fontFamily: 'inherit',
          width: '100%',
          boxSizing: 'border-box',
          color: theme.colors.black,
          backgroundColor: theme.colors.white,
          outline: 'none',
        }}
      />
      {error || hint ? (
        <Text type="bodyExtraSmall" color={error ? theme.colors.error : theme.colors.greyBlue}>
          {error || hint}
        </Text>
      ) : null}
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: { gap: 6, flex: 1, minWidth: 220 },
})
